import { ChatMessageModel } from '../client/SmartAssistantBackendClient';
import { normalizeMessages } from './chatMessageUtils';

const getMessageSignature = (msg: ChatMessageModel | any) => {
  const role = msg?.role ?? '';
  const content = msg?.content ?? '';
  const toolCallIds = Array.isArray(msg?.toolCalls)
    ? msg.toolCalls.map((t: any) => t?.id ?? t?.functionName ?? '').join('|')
    : '';
  const toolResultId = msg?.toolResult?.toolCallId ?? '';
  return `${role}::${content}::${toolCallIds}::${toolResultId}`;
};

const collapseConsecutiveDuplicates = (items: ChatMessageModel[] | any[]) => {
  const result: any[] = [];
  for (const item of items) {
    const prev = result[result.length - 1];
    if (prev && getMessageSignature(prev) === getMessageSignature(item)) {
      continue;
    }
    result.push(item);
  }
  return result as ChatMessageModel[];
};

const findLastAssistant = (items: ChatMessageModel[]) => {
  for (let i = items.length - 1; i >= 0; i -= 1) {
    if (items[i]?.role === 'assistant') return items[i];
  }
  return undefined;
};

const dedupeExactDouble = (value?: string | null) => {
  if (!value) return value ?? '';
  const trimmed = value.trim();
  if (trimmed.length < 200) return value;
  if (trimmed.length % 2 !== 0) return value;
  const mid = trimmed.length / 2;
  if (trimmed.slice(0, mid) === trimmed.slice(mid)) {
    return trimmed.slice(0, mid);
  }
  return value;
};

const replaceLastAssistant = (items: ChatMessageModel[], replacement?: ChatMessageModel) => {
  if (!replacement) return items;
  const last = items[items.length - 1];
  if (last?.role !== 'assistant') return items;
  const next = [...items];
  next[next.length - 1] = replacement;
  return next;
};

export const mergeResponseHistory = (params: {
  normalizedOutgoing: ChatMessageModel[];
  responseTurn: ChatMessageModel[];
}) => {
  const normalizedTurn = params.responseTurn.length > 0
    ? normalizeMessages(params.responseTurn) : [];
  let mergedHistory = normalizedTurn.length > 0
    ? [...params.normalizedOutgoing, ...normalizedTurn]
    : params.normalizedOutgoing;

  const rawFinalAssistant = findLastAssistant(normalizedTurn);
  const finalAssistantFromResponse = rawFinalAssistant
    ? ChatMessageModel.fromJS({
      ...rawFinalAssistant,
      content: dedupeExactDouble(rawFinalAssistant.content),
    })
    : undefined;
  mergedHistory = replaceLastAssistant(mergedHistory, finalAssistantFromResponse);
  mergedHistory = collapseConsecutiveDuplicates(mergedHistory);
  return mergedHistory;
};
